import { render, staticRenderFns } from "./ServiceJoinStep1Contentsogauc.vue?vue&type=template&id=4cbf3e5a"
import script from "./ServiceJoinStep1Contentsogauc.vue?vue&type=script&lang=js"
export * from "./ServiceJoinStep1Contentsogauc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cbf3e5a')) {
      api.createRecord('4cbf3e5a', component.options)
    } else {
      api.reload('4cbf3e5a', component.options)
    }
    module.hot.accept("./ServiceJoinStep1Contentsogauc.vue?vue&type=template&id=4cbf3e5a", function () {
      api.rerender('4cbf3e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ServiceJoinStep1Contentsogauc.vue"
export default component.exports